<script lang="ts">
import { Component } from 'vue-property-decorator'
import ClickableIconSmall from './ClickableIconSm.vue'

@Component({ name: 'ClickableIconMedium' })
export default class ClickableIconMedium extends ClickableIconSmall {
  fontSizeClass = 'is-size-3'
}
</script>
